import { Message } from "element-ui";

import moment from "moment";

export const onlyNumber = value => {
   return value.replace(/\D/g, "");
};

export const metaTags = (title, description, url, imgUrl, tags, htmlAttrs) => {
   let subTitle = title
      ? " | Pedale - Aluguel de Bicicletas"
      : "Pedale - Aluguel de Bicicletas";

   let desc = description
      ? description
      : "Aluguel de bicicletas, através da interação direta entre o dono da bike e quem deseja pedalar. Parece fácil né? E é, conheça a Pedale!";

   let metaTags = {
      htmlAttrs: {
         lang: "pt-BR"
      },
      title,
      titleTemplate: `%s ${subTitle}`,
      meta: [
         { charset: "utf-8" },
         { name: "language", content: "pt-BR" },
         { name: "viewport", content: "width=device-width, initial-scale=1" },
         { name: "description", content: desc },
         {
            name: "keywords",
            content:
               "aluguel de bicicleta,bicicleta,bicicletas,alugar bicicleta,empresar bicicleta,pedalar,aonde pedalar,alugar uma bike, alugar bike"
         },
         { name: "robots", content: "index, follow" },
         { name: "author", content: "Élisson Kario" },
         { name: "og:type", content: "page" },
         { name: "og:url", content: url ? url : "https://pedale.net.br" },
         { name: "og:title", content: title ? title + subTitle : subTitle },
         {
            name: "og:image",
            content: imgUrl
               ? imgUrl
               : "https://pedale.net.br/img/og-imagem-pedale.png"
         },
         { name: "og:description", content: desc }
      ]
   };

   if (tags) {
      metaTags.meta = tags.concat(metaTags.meta);
   }

   if (htmlAttrs) {
      metaTags.htmlAttrs = htmlAttrs;
   }

   return metaTags;
};

export const photoIsOK = (file, size) => {
   const allowedTypes = ["image/jpeg", "image/jpg", "image/png"];

   if (!allowedTypes.includes(file.raw.type)) {
      Message.error("ATENÇÃO: Somente imagens no formato JPEG, JPG e PNG.");
      return false;
   }

   const s = size ? size : 10000000;

   const maxSize = file.raw.size > s * 1000000;

   if (maxSize) {
      Message.error(`Afoto não deve ser maior que ${size}mb`);
      return false;
   }

   return true;
};

export const dailyNumber = (checkin, checkout) => {
   let diff = moment(checkout).diff(moment(checkin), "days");

   if (diff < 0) {
      return 0;
   }

   return diff;
};

export const calcAmountOrder = (dailyNumber, bikePrice) => {
   // Total ref. ao numero de diarias e o valor da diaria da bike.
   let totalDaily = dailyNumber * bikePrice;

   // Taxa da Pedale para o Ciclista, atualmente 11%
   //let cyclistFeePedale = config.cyclistFeePedale / 100

   // Soma do total da diarias + a taxa pedale.
   //let totalPlusCyclistFeePedale = totalDaily * cyclistFeePedale + totalDaily

   // Taxa da juno, atualmente 2.99%
   //let cyclistFeeJuno = config.cyclistFeeJuno / 100

   // Soma do Total das diarias + taxa pedale + taxa juno + taxa de 0.40 fixo por transação, tambem da juno.
   //let totalPlusCyclistFeeJun = totalDaily * cyclistFeeJuno + config.cyclistFixedFeeJuno

   return totalDaily;
};

export const checkPhone = (rule, value, callback) => {
   const phoneno = /^\(\d{2}\) 9\d{4}-\d{4}|\((?:1[2-9]|[2-9]\d)\) [5-9]\d{3}-\d{4}$/;

   if (!value) {
      return callback(new Error("Por favor, digite seu telefone"));
   }

   if (value.match(phoneno)) {
      callback();
   } else {
      return callback(new Error("Telefone inválido"));
   }
};

export const validarCNPJ = cnpj => {
   cnpj = cnpj.replace(/[^\d]+/g, "");

   if (cnpj == "") return false;

   if (cnpj.length != 14) return false;

   // Elimina CNPJs invalidos conhecidos
   if (
      cnpj == "00000000000000" ||
      cnpj == "11111111111111" ||
      cnpj == "22222222222222" ||
      cnpj == "33333333333333" ||
      cnpj == "44444444444444" ||
      cnpj == "55555555555555" ||
      cnpj == "66666666666666" ||
      cnpj == "77777777777777" ||
      cnpj == "88888888888888" ||
      cnpj == "99999999999999"
   )
      return false;

   // Valida DVs
   let tamanho = cnpj.length - 2;
   let numeros = cnpj.substring(0, tamanho);
   let digitos = cnpj.substring(tamanho);
   let soma = 0;
   let pos = tamanho - 7;
   for (let i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--;
      if (pos < 2) pos = 9;
   }
   let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
   if (resultado != digitos.charAt(0)) return false;

   tamanho = tamanho + 1;
   numeros = cnpj.substring(0, tamanho);
   soma = 0;
   pos = tamanho - 7;
   for (let i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--;
      if (pos < 2) pos = 9;
   }
   resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
   if (resultado != digitos.charAt(1)) return false;

   return true;
};

export const validarPassaporte = passaporte => {
   return passaporte.length <= 9 && passaporte.length >= 1;
};

export const formatUSADate = date => {
   let usaDate = date.split("/");
   const day = usaDate[0];
   const month = usaDate[1];
   const year = usaDate[2];

   usaDate = `${year}/${month}/${day}`;
   return moment(usaDate)
      .locale("en")
      .format("YYYY/MM/DD");
};

export const handleTypeOfLease = typeOfLeasePeriod => {
   switch (typeOfLeasePeriod) {
      case "perHour":
         return "hora";
      case "daily":
         return "dia";
      case "perWeek":
         return "semana";
      case "monthly":
         return "mês";
   }
};

export const handleLeaseModality = leaseModality => {
   switch (leaseModality) {
      case "onDemand":
         return "Sob-demanda";
      case "signature":
         return "Assinatura";
   }
};

// Calcula quantas horas o cliente selecionou, em pedalada por hora sob-demanda.
export const timeNumber = (startHourRental, endHourRental) => {
   const startTime = moment(startHourRental, "HH:mm");
   const endTime = moment(endHourRental, "HH:mm");
   const duration = moment.duration(endTime.diff(startTime));
   return duration.asHours();
};
